import { render } from "./NewPartnerRenderer.vue?vue&type=template&id=03239ba4&scoped=true"
const script = {}

import "./NewPartnerRenderer.vue?vue&type=style&index=0&id=03239ba4&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03239ba4"]])

export default __exports__